import axios, { AxiosRequestConfig } from 'axios'
import router from '../router'

axios.defaults.withCredentials = true

axios.interceptors.response.use( response=> {
  // 对响应数据做点什么
  if(response.data.data=='force_login') {
      setTimeout(()=>{
        localStorage.removeItem('ttyh-agents')
          router.replace('/')
      },300)
  }
  return response;
},(error)=> {
  // 对响应错误做点什么
  return Promise.reject(error);
});

type GoodResult<T> = {
  ok: true;
  message: '';
  data: T;
}

type BadResult = {
  ok: false;
  message: string;
  data: null;
}

export async function getJSON<T>(url: string, config?: AxiosRequestConfig | undefined) {
  try {
    const res = await axios.get<GoodResult<T>|BadResult>(url, config)
    return res.data
  } catch (err: any) {
    return {
      ok: false,
      message: err.message,
      data: null
    }
  }
}

export async function request<T>(config: AxiosRequestConfig) {
  try {
    const res = await axios.request<GoodResult<T>|BadResult>(config)
    return res.data
  } catch (err: any) {
    return {
      ok: false,
      message: err.message,
      data: null
    }
  }
}
